import React, { useEffect, useRef, useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from '@mui/icons-material/Clear';
import TextAvatar from "components/avatar/TextAvatar";
import UIButton from "components/ui/form/UIButton";
import { useMediaQuery } from "@mui/material";
import {
  GET_APPOINTMENT_BY_ID,
  GET_LOCATION_BY_ID,
  GET_PATIENT_APPOINTMENT,
  SCHEDULE_APPOINTMENT,
} from "adapters/ehr.service";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { useQuery } from "config/helpers/navigation_helper";
import { useDispatch, useSelector } from "react-redux";
import { toggle_loader } from "redux/actions/AppActions";
import CommonLoader from "components/loader/CommonLoader";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { isDateEqual, formatDateWithOrdinalSuffix } from "config/helpers/date_helper";
import ScheduleAppointmentRightDrawer from "./scheduleAppointmentRightDrawer";
import UISwipeableDrawer from "components/drawers/SwipeableDrawer";
import Confirmation from "components/ui/ConfirmationDialog/ConfirmationDialog";
import Details from "./Details";
import UICard from "components/ui/card/UICard";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { async } from "@firebase/util";

const BookingSuccessful = () => {
  const { i18n } = useTranslation()
  const Navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width:767px)");
  const isMediumScreen = useMediaQuery(
    "(min-width: 768px) and (max-width: 992px)"
  );
  const location = useLocation();
  const query = useQuery(location?.search);
  const id = query.get("id");

  const [bookingDetails, setBookingDetails] = useState();

  const [locationObj, setLocationObj] = useState();

  const [responseState, setResponseState] = useState();

  const [open, setOpen] = useState(false);

  const loading = useSelector((state) => state.app.loader);
  const dispatch = useDispatch();

  const getLocation = async (id) => {
    try{
      dispatch(toggle_loader(true));

      const response = await GET_LOCATION_BY_ID(id);

      setLocationObj(response);
    } catch (e) {
      console.log(e);
    }
  }

  const getPatientAppointment = async (id) => {
    try {
      dispatch(toggle_loader(true));

      const response = await GET_APPOINTMENT_BY_ID(id);

      console.log(response);

      const data = response?.resource;

      setResponseState(data);

      if (data) {
        // Assuming you have two date objects: appointmentState.startTime and currentDate
        const appointmentDate = dayjs(data?.start);
        const currentDate = dayjs();

        // Calculate the difference in days
        const daysDifference = isDateEqual(currentDate, appointmentDate) ? 0 : appointmentDate.diff(currentDate, 'day') > 0 ? appointmentDate.diff(currentDate, 'day') + 1 : appointmentDate.diff(currentDate, 'day');;

        let hoursDiffernce;

        if(daysDifference === 0){
          hoursDiffernce = appointmentDate?.diff(currentDate,'hours');
        }

        let locationData = data?.participant?.filter((f) =>
          f?.actor?.reference?.includes("Location")
        )?.[0]?.actor;

        getLocation(locationData?.reference?.split('/')?.[1])

        let practitionerData = data?.participant?.filter((f) =>
          f?.actor?.reference?.includes("Practitioner")
        )?.[0]?.actor;
        let patientData = data?.participant?.filter((f) =>
          f?.actor?.reference?.includes("Patient")
        )?.[0]?.actor;

        const isTelehealth = data?.serviceType?.[0]?.coding?.[0]?.code === 'telehealth';

        if (locationData && typeof locationData === "object") {
          setBookingDetails({
            ...bookingDetails,
            location: {
              label: locationData?.display,
              reference: locationData?.reference,
            },
            practitioner: {
              label: practitionerData?.display,
              reference: practitionerData?.reference,
            },
            patient: {
              label: patientData?.display,
              reference: patientData?.reference,
            },
            date: appointmentDate,
            startTime: data?.start,
            endTime: data?.end,
            // duration: data?.minutesDuration,
            daysLeft: daysDifference,
            hoursLeft: hoursDiffernce,
            id: data?.id,
            status: data?.status,
            specialty: data?.specality?.[0]?.coding?.[0]?.display,
            appointmentType: data?.appointmentType?.coding?.[0],
            description: data?.description,
            isTelehealth: isTelehealth,
            extension: data?.extension,
          });
        }
      }
    } catch (e) {
      console.error(`Error getting appointment data`, e);
    } finally {
      dispatch(toggle_loader(false));
    }
  };

  useEffect(() => {
    getPatientAppointment(id);
  }, [id]);

  const cancelAppointment = async () => {
    const payload = {
      ...responseState,
      status: "cancelled",
    };

    const response = await SCHEDULE_APPOINTMENT(payload);

    if(response){
      toast?.success(`${i18n?.t('appointments.APPOINTMENT_CANCELLED_SUCCESSFUL')}`);
      
      setTimeout(() => {
        Navigate(`/appointments/details?id=${response?.data?.id}`);
      },[0])
    }


};
  const navigateBack = () => {
    // Navigate("/appointments/upcoming");
    Navigate("/appointments/recent");
  };

  return (
    <>
      <UICard
        jsx
        customClasses='p-0 m-0 booking-detail-card mt-2'
        CardBody={
          <>
            <Confirmation
              open={open}
              setOpen={setOpen}
              message={i18n.t('appointments.DO_YOU_WANT_TO_CANCEL_THIS_APPOINTMENT')}
              callback={cancelAppointment}
              type='appointmentCancellation'
            />
            <div style={{ position: "relative" }}>
              {/* <UISwipeableDrawer
                    open={open}
                    setOpen={setOpen}
                    width={"25%"}
                    appBar={false}
                    jsx={<ScheduleAppointmentRightDrawer appointmentState={bookingDetails} setOpen={setOpen} />}
                /> */}

              <div>
                {loading ? (
                  <CommonLoader />
                ) : (
                  <div>
                    {/* <div
                                    style={{ position: 'absolute', top: '10px', left: '10px', color: 'white' }}
                                    onClick={navigateBack}>
                                    <ArrowBackIosIcon />
                                    <div />
                                </div> */}
                    {(location?.state?.booking || location?.state?.reschedule || bookingDetails?.status === 'cancelled') && (
                      <div
                        className="d-flex justify-content-center align-items-center text-light position-relative"
                        style={{
                          height: "284px",
                          background:
                          location?.state &&
                            "linear-gradient(124.44deg, #585CE5 1.91%, rgba(90, 95, 255, 0.87) 69.55%, rgba(0, 7, 255, 0.68) 139.89%)" ||
                          bookingDetails?.status === 'cancelled' && 
                            "#f82a2adb",
                          borderTopLeftRadius: '20px',
                          borderTopRightRadius: '20px',
                        }}
                      >
                        <div
                          style={{ left: "20px", top: '20px', color: "#FFF" }}
                          onClick={navigateBack}
                          className="mb-4 position-absolute c-pointer"
                        >
                          <KeyboardBackspaceIcon sx={{fontSize: '40px'}} />
                        </div>
                        <div className="d-flex flex-column align-items-center">
                          <div
                            className="rounded rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                              width: "86px",
                              height: "86px",
                              backgroundColor:  bookingDetails?.status === 'cancelled' ? "#8b000042" : "#5A56F1",
                            }}
                          > 
                            {
                              bookingDetails?.status === 'cancelled' ? 
                              <ClearIcon sx={{fontSize: "2.8rem"}}/> :
                              <CheckIcon sx={{ fontSize: "2.8rem" }} />
                            }
                          </div>
                          {
                            location?.state && 
                            <div className="fm b-500 text-center">{location?.state?.booking ? `${i18n.t('appointments.BOOKING_SUCCESSFUL')}` : `${i18n.t('appointments.RESCHEDULING_SUCCESSFUL')}`} </div>
                          }
                          {
                            bookingDetails?.status === 'cancelled' && 
                            <div className="fm b-500">{i18n.t('appointments.CANCELLED')} </div>
                          }
                          <div className="fxs text-center">
                            {i18n.t('appointments.BOOKING_ID')} :{bookingDetails?.id}
                          </div>
                        </div>
                      </div>
                    )}

                    <div>
                      {
                        !(location?.state?.booking || location?.state?.reschedule || bookingDetails?.status === 'cancelled') && 
                        <div
                          // style={{ left: "20px", top: '20px', color: "#FFF" }}
                          onClick={navigateBack}
                          className="mt-3 ms-3 c-pointer"
                        >
                          <KeyboardBackspaceIcon sx={{fontSize: '40px'}} />
                        </div>
                      }
                      <Details
                        bookingDetails={bookingDetails}
                        setOpen={setOpen}
                        locationObj={locationObj}
                      />
                    </div>

                  </div>
                )}
              </div>
            </div>
          </>
        }
      />
    </>
  );
};

export default BookingSuccessful;
